var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',[_c('document-link',{staticClass:"dashboard-link has-text-normal is-flex has-hover-background",attrs:{"document":_vm.article}},[_c('span',{staticClass:"dashboard-link-main"},[_c('document-title',{staticClass:"document-title",attrs:{"document":_vm.article}})],1),_vm._v(" "),_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }